import { createContext, useContext } from 'react';
import { ItemPureProps } from './types';

export const ItemContext = createContext<ItemPureProps | undefined>(undefined);

export const useItemContext = () => {
  const value = useContext(ItemContext);
  if (!value) {
    throw new Error('Can not find item context. Did you forget to wrap your component with <ItemContext.Provider/>?');
  }
  return value;
};
